import type { FormField } from '@cli-types/core-engine/schema.js'
import { jsString } from '@cli-utils/text.js'

export function buildDefaultValues(fields: FormField[]): string {
  return fields
    .filter((f) => f.name)
    .map((f) => {
      if (f.type === 'checkbox') {
        return f.options && f.options.length > 0 ? `      ${f.name}: []` : `      ${f.name}: false`
      }
      if (f.type === 'number') return `      ${f.name}: undefined`
      if (f.type === 'multiselect' || f.type === 'list') return `      ${f.name}: []`
      if (f.type === 'radio' && f.defaultValue !== undefined)
        return `      ${f.name}: ${jsString(String(f.defaultValue))}`
      if (f.type === 'select' || f.type === 'radio') return `      ${f.name}: undefined`
      if (f.defaultValue !== undefined)
        return `      ${f.name}: ${jsString(String(f.defaultValue))}`
      return `      ${f.name}: ''`
    })
    .join(',\n')
}
